import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse } from "../helpers";
import { api } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class BusinessRating extends Mediator {
	$$businessRating = {
		needs: {
			rateItem: (ed, event) => this.rateItem(ed, event),
		},
	};

	async rateItem(ed, event) {
		let { message } = eParse(ed);

		const orderItemId = message.get("orderItemId");
		const companyId = message.get("companyId");
		const rating = message.get("rating");

		let res = await api.put(
			`${routes.orderItems}/${orderItemId}/review`,
			{
				company_id: companyId,
				rating,
			},
			{ silent: true },
		);

		if (!res) {
			return this.send(
				$e.businessRating.itemRatingFailed,
				payload({ orderItemId }),
			);
		}

		return this.send(
			$e.businessRating.itemRated,
			payload({ orderItemId, review: res.data?.review }),
		);
	}
}
